import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { Box, Stack } from '@mui/material'
import { useHagerBridgePermissions } from 'src/Libs/e-mobility/shared'
import { useFetchChargingCards } from '../../charging-cards/api/use-fetch-charging-cards'
import { WallboxCards } from './WallboxCards'
import { WallboxSkeleton } from './WallboxSkeleton'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { ChargingCardToWallboxLinkDialogButton } from '../../charging-cards/components/link-wallboxes/ChargingCardToWallboxLinkDialogButton'

interface WallboxesProps {
  installationId: number
  installationCountryCode: string
}

/** This component represents Wallboxes Page overview */
export const Wallboxes: React.FC<WallboxesProps> = ({ installationId, installationCountryCode }) => {
  const { t } = useCustomTranslation()
  const { wallboxes, chargingCards, isError, isLoading } = useFetchChargingCards(installationId)
  const { permissions } = useHagerBridgePermissions()

  if (isLoading) {
    return <WallboxSkeleton />
  }

  if (isError) {
    return <ErrorMessage title={t('emobility.wallbox.error-message')} />
  }

  return (
    <>
      {permissions.tourGuidePermissions.viewTourGuide && <BannerQueue location={BannerLocations.EmobilityTour} />}
      <BannerQueue location={BannerLocations.EmobilityCountryInfoMissingWallboxes} />

      <Stack>
        <Box alignSelf="end" mb={1}>
          <ChargingCardToWallboxLinkDialogButton
            installationId={installationId}
            chargingCards={chargingCards}
            installationHasWallboxes={wallboxes.length > 0}
          />
        </Box>

        <WallboxCards wallboxes={wallboxes} installationId={installationId} />
      </Stack>
    </>
  )
}
